import React from 'react'
import { Switch, useRouteMatch } from 'react-router-dom'
import urljoin from 'url-join'

import { DomainPermission_VerbEnum, DomainPermission_DomainEnum } from 'src/api/gen'
import RestrictedRoute from 'src/layout/RestrictedRoute'

import { SmartPatrol } from './SmartPatrol'
import SmartPatrolImageDownloader from './SmartPatrolImageDownloader'

export default function SmartPatrolRouter() {
  const { url } = useRouteMatch()
  return (
    <Switch>
      <RestrictedRoute
        exact
        path={urljoin(url, 'export-pictures', ':offenseId')}
        component={SmartPatrolImageDownloader}
        requiredPermissions={[[DomainPermission_VerbEnum.read, DomainPermission_DomainEnum.smart_patrol]]}
      />
      <RestrictedRoute
        exact
        path={url}
        component={SmartPatrol}
        requiredPermissions={[[DomainPermission_VerbEnum.read, DomainPermission_DomainEnum.smart_patrol]]}
      />
    </Switch>
  )
}
